import { inject } from 'vue'

const orderEventsNamespaceKey = 'orderEventsNamespace'

export const provideOrderEventNamespace = (app, namepsace) => {
  app.provide(orderEventsNamespaceKey, namepsace.replace(/\.$/, ''))
}

export const useOrderEvents = ({ eventSource = window, appendTs = true } = {}) => {
  const namespace = inject(orderEventsNamespaceKey)

  const emit = (ce) => {
    return eventSource.dispatchEvent(ce)
  }

  return { emit, namespace, eventSource }
}
